import {
  File,
  FileImage,
  FileSpreadsheet,
  FileText,
  FileType,
  type LucideIcon,
  Presentation,
} from "lucide-react";

export type MediaKind = "document" | "spreadsheet" | "presentation" | "image" | "text" | "file";

const KIND_ICON: Record<MediaKind, LucideIcon> = {
  document: FileText,
  spreadsheet: FileSpreadsheet,
  presentation: Presentation,
  image: FileImage,
  text: FileType,
  file: File,
};

/** The kind of a media type, for its icon and label only: never a reason to read content. */
export function mediaKind(mediaType: string | null | undefined): MediaKind {
  const type = (mediaType ?? "").toLowerCase().split(";")[0]?.trim() ?? "";
  if (type.startsWith("image/")) {
    return "image";
  }
  if (type === "text/csv" || type.includes("spreadsheetml") || type.includes("ms-excel")) {
    return "spreadsheet";
  }
  if (type.includes("presentationml") || type.includes("ms-powerpoint")) {
    return "presentation";
  }
  if (
    type === "application/pdf" ||
    type.includes("wordprocessingml") ||
    type === "application/msword"
  ) {
    return "document";
  }
  if (type.startsWith("text/")) {
    return "text";
  }
  return "file";
}

export const mediaIcon = (mediaType: string | null | undefined): LucideIcon =>
  KIND_ICON[mediaKind(mediaType)];
